import { render, staticRenderFns } from "./taskToInqu.vue?vue&type=template&id=07a7707b&scoped=true&"
import script from "./taskToInqu.vue?vue&type=script&lang=js&"
export * from "./taskToInqu.vue?vue&type=script&lang=js&"
import style0 from "./taskToInqu.vue?vue&type=style&index=0&id=07a7707b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7707b",
  null
  
)

export default component.exports